module.exports = __webpack_public_path__ + "static/media/reminder-blue.d3fa3f14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/reminder-blue.svg
// module id = 128
// module chunks = 0